/*
 * Developed by HuMingZhi on 12/29/18 5:56 PM
 * Copyright (c) 2018. All right reserved.
 */
/* eslint-disable no-unused-vars, eqeqeq */
import { cacheWrap } from '../utils/cacheWrap';
/**
 * @returns {boolean} webp格式图片是否支持
 */
export var isWebpSupport = cacheWrap(function cachedFunction() {
    var elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
});
